<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="pledgeOwners"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (
        pledgeOwner of pledgeOwners.controls;
        track pledgeOwner;
        let i = $index
      ) {
        <mat-step
          [formGroup]="pledgeOwner"
          [stepControl]="pledgeOwners?.get([i])"
          completed="false"
        >
          <ng-container formGroupName="antiMoneyLaundering">
            <ng-template matStepLabel>{{
              pledgeOwner?.get('company')?.get('name')?.value
            }}</ng-template>
            <mat-accordion class="example-headers-align">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Risque client - Personne morale
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="institutionFinanciere"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Institution financière"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Institution financière régulée établie en France ou dans un autre Etat de l'EEE ou dans un pays tiers imposant des obligations équivalentes en matière de LCB-FT (art. R561-15 CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="autoriteOrganismePublic"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Autorité publique ou organisme public"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Autorité publique ou organisme public (art. R561-15 CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="societeCotee"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Société cotée"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Société dont les titres sont admis à la négociation sur un marché réglementé en France ou dans un Etat partie à l’accord sur l’EEE ou dans un pays tiers imposant des exigences de publicité reconnues comme équivalentes par la Commission européenne (art. R561-15 CMF)."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="rbePpe"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Bénéficiaire effectif est une PPE"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Le bénéficiaire effectif est une PPE (art. L561-10 et R561-18 du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="structureAnonymat"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Structure favorisant l’anonymat"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Personne morale constituée sous forme de structure favorisant l'anonymat (art. L561-10 du CMF) comme la fiducie ou son  équivalent étranger (trust anglo saxon, fiducie suisse, Treuhand allemande, fondation au Liechtenstein, etc.)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="recoursDomiciliation"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Recours à une domiciliation"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Recours à une société de domiciliation."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="secteurCorruptionBlanchiment"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Secteur avec risque de corruption ou de blanchiment"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Personne morale ou bénéficiaire effectif exercant dans des secteurs communément associés à un risque de corruption ou de blanchiment plus élevé."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="changementStatutsSansJustification"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Changement statuts sans justification"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Changements réguliers de statuts sans justification de la situation économique de l'entreprise."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="representantDiscretionInhabituelle"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Représentant avec discrétion inhabituelle"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Représentant légal qui exige un niveau de confidentialité ou de discrétion inhabituellement élevé."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="personneListeGelsDesAvoirs"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Personne morale sur la liste des gels des avoirs ?"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Personnes morales inscrites sur la liste de Gel des Avoirs."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="fondListeGelsDesAvoirs"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Fond provenant d’une personne morale sur la liste des gels des avoirs ?"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Personnes morales inscrites sur la liste de Gel des Avoirs."
                    />
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title> Risques produits </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="versementPeePerco"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Versement PEE ou PERCO >8000€ ou versement par un tiers"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Sommes versées sur un PEE ou un PERCO, à l'exception des versements volontaires qui dépassent 8.000 euros ou qui ne sont pas effectués à partir d'un compte ouvert au nom du bénéficiaire ou de son employeur (art. R561-16 7° et 8° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="produitsAtypiques"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Produits atypiques"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Produits atypiques / fonds ne faisant pas appel public à l'épargne (autres FIA, parts sociales, biens divers, etc.)"
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="controleActifsFonds"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrôle sur les actifs du fonds"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Les investisseurs exercent un contrôle sur les actifs du fonds."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="compteTitreAugmentationCapital"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Compte titre pour augmentation de capital >15000€"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Comptes-titres aux fins de bénéficier d'une augmentation de capital réservée, d'actions gratuites, d'options de souscription ou d'achat d'actions et qui ne dépassent pas une valeur de 15.000 euros (art. R561-16 9° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="primeAnnuelleUnique"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Prime annuelle >1000€ ou prime unique >2500€"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Prime annuelle supérieure à 1.000 € ou prime unique supérieure à 2.500 € versée sur un contrat d’assurance vie ou de capitalisation (art. R561-16 1° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="contratPrevoyanceSante"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrat prévoyance ou santé"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrats de prévoyance collective ou individuelle ; complémentaires santé et accident (art. R561-16 2° du CMF)"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="assuranceEmprunteur"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Assurance emprunteur"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrats d'assurance emprunteur (art. R561-16 4° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="contratAssuranceSansClauseRachat"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrat d'assurance retraite sans clause de rachat"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrat d'assurance retraite qui ne comportent pas de clause de rachat (art. R561-16 3° du CMF) tels que les PERP, loi 'Madelin', PERE, 'article 83' et 'article 39'"
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="contratAnonyme"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrat anonyme"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrat favorisant l'anonymat (art. L561-10 du CMF) : bon ou contrat de capitalisation anonyme."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="produitsImmobiliersLuxe"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Produits immobiliers de luxe"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Biens résidentiels de luxe et de prestige, particulièrement à Paris, sur la Côte d’Azur et dans les départements et collectivités d’Outre-mer."
                    />
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title> Risques pays </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="operationPaysGafi"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Opération avec pays liste GAFI"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Opération pour compte propre ou pour compte de tiers effectuée avec des personnes physiques ou morales, y compris leurs filiales ou établissements ou toute autre entité, domiciliées, enregistrées ou établies dans un Etat ou un territoire figurant sur les listes publiées par le GAFI parmi ceux dont la législation ou les pratiques font obstacle à la LCB-FT ou par la Commission européenne en application de l'article 9 de la directive (UE) 2015/849 du 20 mai 2015 relative à la prévention de l'utilisation du système financier aux fins du blanchiment de capitaux ou du financement du terrorisme (art. L561-10 du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="fondPaysGafi"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Fond provenant d’un pays liste GAFI"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Fonds en provenance ou à destination d'un Etat ou un territoire figurant sur les listes publiées par le GAFI parmi ceux dont la législation ou les pratiques font obstacle à la LCB-FT ou par la Commission européenne en application de l'article 9 de la directive (UE) 2015/849 du 20 mai 2015 relative à la prévention de l'utilisation du système financier aux fins du blanchiment de capitaux ou du financement du terrorisme."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="operationPaysNonCooperatif"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Opération avec pays non coopératif"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Personnes physiques établies ou situées dans un pays non coopératif en matière fiscale selon  l’article 238-0 A du CGI."
                    />
                  </div>
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="fondPaysNonCooperatif"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Fond provenant d’un pays non coopératif "
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Fonds en provenance ou à destination d'un pays non coopératif en matière fiscale selon l’article 238-0 A du CGI."
                    />
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>
        </mat-step>
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
